import { AttachmentData } from "@/repository/models/message";
import {
	fetchHistoryMessageInlineAttachments,
	fetchInlineAttachments,
	InlineAttachmentsKey,
} from "@/repository/queryFns";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";

export interface EmailHookProps {
	sessionId: string;
	messageId: string;
	isHistory: boolean;
	isPreview: boolean;
}

export interface HookResult {
	inline: AttachmentData[];
	trigger: () => void;
}

export const useInlineAttachments = (props: EmailHookProps): HookResult => {
	const { sessionId, messageId, isHistory, isPreview } = props;
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const queryAttachments = useQuery({
		queryFn: () =>
			isHistory
				? fetchHistoryMessageInlineAttachments(sessionId, messageId)
				: fetchInlineAttachments(sessionId, isPreview, messageId),
		queryKey: [InlineAttachmentsKey, props.messageId],
		enabled: isOpen,
	});

	const trigger = useCallback(() => setIsOpen(true), [setIsOpen]);

	return useMemo<HookResult>(
		() => ({
			inline: queryAttachments.data || [],
			trigger,
		}),
		[queryAttachments.data]
	);
};
